import { BrowserRouter, Routes, Route } from "react-router-dom";
// npm install react-router-dom
import Home from "./pages/index"
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/course/*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
